import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ButtonBase from './Buttons/ButtonBase';

const EmptyState = ({ title, subtitle, img, callToAction, handleClick, direction, imgAlign, buttonStyles }) => {
  return (
    <div className="flexContainer--center">
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{ height: 'calc(100vh - 64px)', padding: '0 32px' }}
      >
        <Grid item xs={12} md={7} lg={7}>
          <Typography
            style={{
              fontSize: '28px',
              fontWeight: 'bold',
              color: '#10587f',
              lineHeight: 'normal',
            }}
          >
            {title}
          </Typography>
          <br />
          <Typography
            style={{
              fontSize: '18px',
              color: '#10587f'
            }}
          >
            {subtitle}
          </Typography>
          <br />
          {callToAction &&
            <ButtonBase
              direction={direction ? direction : null}
              onClick={handleClick}
              variant="secondary"
              style={buttonStyles ? buttonStyles : { width: 186, padding:0}}
            >
              {callToAction}
            </ButtonBase>
          }
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <div style={{ textAlign: imgAlign ?  imgAlign : 'right' }}>
            <img src={img} alt="" />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default EmptyState;
